import CollectionPage from 'src/components/pages/Content/CollectionPage/CollectionPage';

export default CollectionPage;
